/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MigrationRequest } from '../../models/migration-request';
import { MigrationSimulation } from '../../models/migration-simulation';

export interface ApiRequestMigrationSimulatePost$Params {
  stage?: string;
      body?: MigrationRequest
}

export function apiRequestMigrationSimulatePost(http: HttpClient, rootUrl: string, params?: ApiRequestMigrationSimulatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationSimulation>> {
  const rb = new RequestBuilder(rootUrl, apiRequestMigrationSimulatePost.PATH, 'post');
  if (params) {
    rb.query('stage', params.stage, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MigrationSimulation>;
    })
  );
}

apiRequestMigrationSimulatePost.PATH = '/api/Request/Migration/Simulate';
